import { render, staticRenderFns } from "./ApplicantBusinessData.vue?vue&type=template&id=037967d4&"
import script from "./ApplicantBusinessData.vue?vue&type=script&lang=js&"
export * from "./ApplicantBusinessData.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantBusinessData.vue?vue&type=style&index=0&id=037967d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports